// @flow
import { createLogger } from "redux-logger";

const blacklist = ["@@router/LOCATION_CHANGE", "@@router/CALL_HISTORY_METHOD"];

const Logger = createLogger({
  predicate: (getState, action) => !blacklist.includes(action.type)
});

export default Logger;
